// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
    baseURL: process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_LOGIN_API_PROD_URL
        : process.env.REACT_APP_LOGIN_API_URL,
    headers: {
        "Content-Type": "application/json",
    }

});
export default axiosInstance;
